import React, { useState } from "react";
import { Typography, Box } from "@mui/material";
import VideoThumbnail from "./VideoThumbnail";

const ThumbnailMapper = ({ files, thumbnails, onMappingChange }) => {
  const [mappings, setMappings] = useState({});
  const handleMappingChange = (fileName, thumbnailIndex) => {
    const newMappings = { ...mappings };
    newMappings[fileName] = thumbnails[thumbnailIndex];
    setMappings(newMappings);
  };
  console.log(mappings, "mappings");

  return (
    <div>
      <h2>List Of files Along With Their Thumbnails</h2>
      {files.map((file) => (
        <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
          key={file.name}
          className="mapping"
          fullWidth
        >
          <Typography component={"span"}>{file.name}</Typography>
          <select
            onChange={(e) => handleMappingChange(file.name, e.target.value)}
          >
            <option value="">Select Thumbnail</option>
            {thumbnails.map((thumbnail, index) => (
              <option key={thumbnail.name} value={index}>
                {thumbnail.name}
              </option>
            ))}
          </select>
          {mappings[file.name]?.getUrl ? (
            <embed src={mappings[file.name]?.getUrl} width={100} height={100} />
          ) : mappings[file.name] ? (
            <img
              src={URL.createObjectURL(mappings[file.name])}
              alt={`Thumbnail for ${file.name}`}
              width="100"
            />
          ) : null}
        </Box>
      ))}
    </div>
  );
};

export default ThumbnailMapper;
